import React from 'react';
import { Link } from 'react-router-dom';

const SourceLink = props => {
  /* eslint-disable jsx-a11y/anchor-has-content */
  return <Link to="/" {...props} />;
};

export default SourceLink;
